export default __webpack_public_path__ + "static/media/mentorship.e6717069.jpg";